<template>
  <kt-modal :visible="true" title="Clock Stopped" @dismiss="onClose">
    <template #body>
      <!-- Job Summary Pane -->
      <div class="card bg-light mb-4">
        <div class="card-body">
          <div class="mb-2">
            <small class="text-muted text-uppercase">Client</small>
            <p class="mb-1 fw-semibold">{{ data?.client?.Company || 'Unknown Client' }}</p>
          </div>
          <div class="mb-2">
            <small class="text-muted text-uppercase">Job</small>
            <p class="mb-1 fw-semibold">{{ jobName }}</p>
          </div>
          <div class="mb-0">
            <small class="text-muted text-uppercase">Job ID</small>
            <p class="mb-0">{{ data?.request?.Id || data?.task?.RequestId || '-' }}</p>
          </div>
        </div>
      </div>

      <!-- Action Buttons -->
      <div class="d-flex gap-3">
        <button class="btn btn-primary flex-fill" @click="onViewJob">
          <FolderOpen :size="18" class="me-2" />
          View Job
        </button>
        <button class="btn btn-success flex-fill" @click="onAddFollowup">
          <PlusCircle :size="18" class="me-2" />
          Add Follow-up
        </button>
      </div>
    </template>

    <template #footer>
      <button class="btn btn-outline-secondary" @click="onClose">
        Close
      </button>
    </template>
  </kt-modal>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import KtModal from '@/components/UI/KtModal.vue';
import { FolderOpen, PlusCircle } from 'lucide-vue-next';

const props = defineProps<{
  data: {
    task?: any;
    clock?: any;
    request?: any;
    client?: any;
  } | null;
}>();

const emit = defineEmits<{
  (e: 'close'): void;
  (e: 'view-job', jobId: number): void;
  (e: 'add-followup', payload: any): void;
}>();

const jobName = computed(() => {
  const req = props.data?.request;
  if (!req) return '(No description)';
  return req.RequestDetailedDescription || req.TaskDetail || '(No description)';
});

const onViewJob = () => {
  const jobId = props.data?.request?.Id || props.data?.task?.RequestId;
  if (jobId) {
    emit('view-job', jobId);
  }
  emit('close');
};

const onAddFollowup = () => {
  const request = props.data?.request;
  const task = props.data?.task;
  const client = props.data?.client;

  const requestId = request?.Id || task?.RequestId;
  const clientId = client?.CustomerNumber || client?.Id || null;
  const techId = task?.AssignedTo || null;

  const payload = {
    id: null, // New task
    requestId: requestId,
    clientId: clientId,
    techId: techId,
    followUp: true
  };

  emit('add-followup', payload);
  emit('close');
};

const onClose = () => {
  emit('close');
};
</script>
